import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button as AntdButton } from 'antd';
import './button.less';
import * as classnames from 'classnames';

export default class Button extends Component {
  static propTypes = {
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
    htmlType: PropTypes.string
  };

  onClick = () => {
    if (!this.props.disabled && this.props.onClick) {
      this.props.onClick();
    }
  };
  render() {
    return (
      <AntdButton
        htmlType={this.props.htmlType}
        type={this.props.active !== false ? 'primary' : null}
        onClick={this.onClick}
        disabled={this.props.disabled}
        className={classnames(this.props.className, 'button', {
          disabled: this.props.disabled
        })}
      >
        {this.props.children}
      </AntdButton>
    );
  }
}
